var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0d6efd",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 240",
    xmlSpace: "preserve",
    width: "28px",
    height: "28px",
    stroke: "#0d6efd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,168h60v12H52v8h40v-8H76v-12h64c2.211,0,4-1.789,4-4V80c0-2.211-1.789-4-4-4H8c-2.211,0-4,1.789-4,4v84 C4,166.211,5.789,168,8,168z M12,84h124v76H76h-8H12V84z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 60,
    width: 40,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,108c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S202.617,108,196,108z M196,124c-2.207,0-4-1.793-4-4 c0-2.207,1.793-4,4-4c2.207,0,4,1.793,4,4C200,122.207,198.207,124,196,124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.172,93.172l-24,24c-1.562,1.562-1.562,4.094,0,5.656C25.953,123.609,26.976,124,28,124s2.047-0.391,2.828-1.172 l24-24c1.562-1.562,1.562-4.094,0-5.656C53.266,91.609,50.734,91.609,49.172,93.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,192V44c0-2.211-1.789-4-4-4h-64c-2.211,0-4,1.789-4,4v148H0v8h156h64h20v-8H224z M216,192h-56V48h56V192z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSvgrepoCom);
export default __webpack_public_path__ + "static/media/desktop-svgrepo-com.87b57c73ab3ec53330ab9733b1b019e1.svg";
export { ForwardRef as ReactComponent };